export const fullAccessUsersPage = {
	heading: {
		sv: "Användare",
	},
	subHeading: {
		sv: "Här kan du lägga till vilka användare som ska ha full tillgång till bankens tjänster.",
	},
	assignedUsers: {
		heading: {
			sv: "Användare med full tillgång",
		},
		subHeading: {
			sv: "Du är redan tillagd som en person med full tillgång till bankens tjänster",
		},
	},
	unAssignedUsers: {
		heading: {
			sv: "Lägg till fler personer med full tillgång",
		},
		subHeading: {
			sv: `De här användarna kommer ha full tillgång till bankens tjänster. Vill du lägga till fler
        användare kan du även göra det senare i internetbanken.`,
		},
	},
};
